module.exports = __webpack_public_path__ + "static/img/dataserviceIndex_4.4c486496.svg";